import globalConfig from '../config/global-variables'
import getRequestURL from '../utils/getRequestURL';

var forgotPasswordModel = {

  forgot: function (successCallBack, failureCallBack, email) {
    var params = {}
    params.userIDOrEmail = email
    m.request({
      method: 'POST',
      url: getRequestURL('/api/account/forgetpassword'),
      headers: { 'Access-Control-Allow-Origin': '*' },
      body: params
    })
      .then(function (result) {
        successCallBack(result)
      })
      .catch(function (error) {
        failureCallBack(error)
      })
  }
}

export default forgotPasswordModel;
